import request from '@/utils/request'

// 获取考试课程
export function getMyExercisesCourses(ids) {
    return request({
        url: '/hdjg/course/get-my-exercises?ids=' + ids,
        method: 'get'
    })
}

// 获取课程
export function getCourseById(id) {
    return request({
        url: '/hdjg/course/get-course?id=' + id,
        method: 'get'
    })
}

// 获取考试课程详情
export function getCourseChapter(id, classId) {
    return request({
        url: '/hdjg/course/chapter/get/course/chapter?id=' + id + '&classId=' + classId,
        method: 'get'
    })
}